import Vue from "vue";
import VueRouter from "vue-router";
import App from "@/App.vue";
import {router} from "@/util/router.js";
import store from "./store";
import {TDSDate} from "@/util/TDSDate";

Vue.config.productionTip = false;

Vue.use(VueRouter);

Vue.filter("dateFormat", (value, format) => {
  if (typeof value !== "string") return value;
  // @ts-ignore
  return new TDSDate(value).format(format || "DD.MM.YYYY");
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
